import React from "react";
import useNotifications from "../../hooks/useNotifications";
import "./Notifications.css";
import { useNavigate } from "react-router-dom";
import { Trash2 } from "lucide-react";
import { toast } from "react-toastify";

const Notifications = ({ onReadAll }) => {
  const token = localStorage.getItem("access_token");
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { notifications, setNotifications } = useNotifications();
  const navigate = useNavigate();

  const handleClick = (n) => {
    if (onReadAll) onReadAll();

    switch (n.message_identype) {
      case "message":
        navigate(`/chat?userId=${n.user_profile.id}`);
        break;

      case "connection_request":
        navigate(`/user-profile/${n.user_profile.id}`);
        break;

      case "collaborator_invitation":
        navigate(`/profile-view?tab=invitations`);
        break;

      default:
        navigate(`/user-profile/${n.user_profile.id}`);
    }
  };

  const deleteNotification = async (notificationId) => {
    try {
      const response = await fetch(`${BASE_URL}/user/chat/notification/`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_X_API_KEY
        },
        body: JSON.stringify({ notification_id: notificationId }),
      });

      if (response.ok) {
        setNotifications((prev) =>
          prev.filter((notif) => notif.id !== notificationId)
        );
        toast.success("Notification deleted!");
      } else {
        const data = await response.json();
        toast.error(data?.detail || "Failed to delete notification");
      }
    } catch (err) {
      console.error("Failed to delete notification:", err);
      toast.error("Failed to delete notification.");
    }
  };

  return (
    <div className="notification-popup">
      <h3 className="notification-title">Notifications</h3>
      {notifications.length === 0 ? (
        <p className="no-notifications">No new notifications</p>
      ) : (
        <ul className="notification-list">
          {notifications?.map((n, index) => (
            <li
              key={n.id}
              className="notification-item"
              onClick={() => handleClick(n)}
            >
              <img
                src={n.user_profile?.profile_picture}
                alt={n.user_profile?.name || "User"}
                className="notification-avatar"
              />
              <div className="notification-text">
                <strong>{n.user_profile?.name}</strong> {n.message}
                <span className="notification-time">{n.timestamp}</span>
              </div>
              <Trash2
                className="notification-trash"
                size={16}
                onClick={(e) => {
                  e.stopPropagation();
                  deleteNotification(n.id);
                }}
              />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Notifications;
